<template>
  <div class="project-overview">
    <slot name="new-project-dialog"/>
    <div class="projects-overview-action-bar">
      <slot name="action_bar"/>
    </div>
    <div
      class="projects-overview-projects"
      :style="`
        grid-template-columns: repeat(auto-fill, minmax(min(${on_site_width || 480}px, 100%), 1fr));
        padding: ${padding || '10px'};
      `"
    >
      <slot name="projects"/>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    'on_site_width',
    'padding',
  ],
  components: {
  },
  data: () => ({
  }),
  methods: {
  },
}

</script>
<style>
  .projects-overview-action-bar {
    display: flex;
    justify-content: space-between;
    width: 100vw;
    flex-wrap: wrap;
    padding-left: 10px;
    padding-right: 10px;
    /* border-bottom: 1px solid var(--v-primary-base); */
    top: 0px;
    z-index: 50;
    position: sticky;
    overflow-x: hidden;
    background-color: var(--v-color-1-base);
    min-height: 50px;
  }

  .projects-overview-projects {
    padding: 10px;
    position: absolute;
    display: grid;
    grid-gap: 10px;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(min(480px, 100%), 1fr));
    grid-auto-rows: minmax(min-content, max-content);
  }

  .project-overview {
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
</style>
